var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHearing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 100,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 106,
    height: 100,
    rx: 50,
    fill: "#F7F8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_2490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5769 44.9867C61.7599 42.8042 61.0995 40.6346 59.7317 38.9242C58.3638 37.2138 56.3924 36.0927 54.2231 35.7914C53.7537 35.7237 50.3829 35.3075 47.5517 37.7055C45.2287 39.6728 44.7568 42.429 44.6479 43.0291C44.6479 43.0726 44.6116 43.2444 44.5826 43.4525C44.4181 44.7375 44.4277 47.0097 46.0054 50.1264C44.3479 46.9661 43.9631 43.9534 45.3037 42.625C45.8796 42.0539 46.6564 41.9305 48.2123 41.6885C50.2014 41.3788 52.0138 41.0981 53.8964 41.9982C56.28 43.1355 57.2237 45.4247 57.6036 46.3418C57.9109 47.0823 59.0555 49.8384 57.8311 52.8922C57.6229 53.4125 56.7446 55.6169 54.6393 56.7228C53.577 57.2793 52.9455 57.1608 51.6121 57.8964C50.6373 58.4048 49.7755 59.1053 49.0786 59.9556C47.5033 61.9447 48.3067 63.295 46.7314 64.8993C46.3587 65.2768 45.3763 66.2786 44.0938 66.1745C43.0993 66.0947 42.0902 65.3639 41.5336 64.5242C41.5336 64.5242 41.4925 64.4613 41.4586 64.4032C41.1828 63.9435 40.6988 62.8013 41.3764 60.3888",
    stroke: "#4540DB",
    strokeWidth: 1.69387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1287 39.1791C39.7531 37.4779 40.6238 35.8775 41.713 34.4291C42.7245 33.0788 44.2465 31.1042 47.0027 29.725C49.3219 28.5989 51.9064 28.1334 54.4727 28.3795C56.4977 28.5142 58.4739 29.0609 60.2802 29.9863C62.0228 30.9183 63.5569 32.1962 64.7883 33.7418C66.9349 36.3334 68.2967 39.4841 68.7132 42.8234C69.1972 47.179 67.801 50.4845 67.167 51.9364C65.9426 54.7458 64.3189 56.5921 62.8742 58.2279C59.9898 61.5309 58.8065 61.5309 56.7255 64.5412C56.3746 65.0493 55.564 66.5786 53.9476 69.6373C51.8012 73.6929 51.4358 74.5979 50.1485 75.6311C48.7927 76.7623 47.0956 77.4041 45.3306 77.4533C43.5523 77.4601 41.8269 76.8485 40.4499 75.7231C37.5098 73.2912 37.6453 69.5502 37.6695 69.1122",
    stroke: "#4540DB",
    strokeWidth: 1.69387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2296 28.4399C55.7813 26.3637 56.3322 24.2867 56.8823 22.2089C59.3693 22.6804 61.762 23.5567 63.9651 24.803C65.3686 25.5991 68.3982 27.3583 70.7599 30.6928C73.8888 35.1089 74.0364 39.7356 74.1477 42.9273C74.3174 47.9817 73.1185 52.988 70.6777 57.4171C69.3187 59.8598 67.5972 62.0822 65.5719 64.0087L60.9283 60.2338C63.5335 58.1057 65.6093 55.402 66.9923 52.3355C67.7182 50.6973 68.9596 47.8323 68.7975 43.9703C68.7418 42.6563 68.4587 37.7465 64.5798 33.5022C62.1091 30.8265 58.8206 29.0461 55.2296 28.4399Z",
    fill: "#BEBCFA",
    stroke: "#4540DB",
    strokeWidth: 1.69387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8929 24.2272C53.9571 23.7302 51.9446 23.6046 49.962 23.8569C44.832 24.5224 41.5798 27.5834 40.2828 28.8393C39.16 29.9282 35.5423 33.5337 34.7172 39.4671C34.3332 42.3273 34.6462 45.2378 35.6295 47.951",
    stroke: "#4540DB",
    strokeWidth: 1.69387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2233 47.496C38.6032 47.5105 40.3044 47.5783 41.4755 48.8559C43.0726 50.5958 43.0242 53.8552 41.1053 55.6507C39.6534 57.001 37.553 57.1559 35.9584 56.5582C35.3171 56.3162 33.5386 55.4983 32.9917 53.5503C32.4061 51.4403 33.7564 49.7149 34.1459 49.2673C34.296 49.0955 35.8084 47.404 38.2233 47.496Z",
    fill: "#BEBCFA",
    stroke: "#4540DB",
    strokeWidth: 1.69387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_2490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 56.9381,
    fill: "white",
    transform: "translate(32 21.3621)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearing);
export default __webpack_public_path__ + "static/media/Hearing.050f9c867dbb4abcc865b44ccf0fa419.svg";
export { ForwardRef as ReactComponent };